import React, { useCallback } from "react";

import { graphql, useFragment } from "react-relay";
import { TeamScheduleRoutineOccasionListItem } from "./TeamScheduleRoutineOccasionListItem";

import { TeamScheduleInlineRoutineOccasionListItem } from "./TeamScheduleInlineRoutineOccasionListItem";
import { TeamScheduleListItem_TeamScheduleEventOccasion$key } from "./__generated__/TeamScheduleListItem_TeamScheduleEventOccasion.graphql";
import { TeamScheduleListItemTimeOfDay } from "./TeamScheduleListItemTimeOfDay";
import { TeamScheduleListItemWrapper } from "./TeamScheduleListItemWrapper";

export const TeamScheduleListItem = React.memo(TeamScheduleListItemC);

function TeamScheduleListItemC(props: {
  teamColor: string;
  eventOccasion: TeamScheduleListItem_TeamScheduleEventOccasion$key;
  itemType: "timeOfDay" | "WEEKLY" | "MONTHLY";
  status: "active" | "soon" | "none";
  isFirst: boolean;
  isLast: boolean;
  radius?: "medium" | "large";
  border?: boolean;
  showSeparator?: boolean;
}) {
  const eventOccasion = useFragment(
    graphql`
      fragment TeamScheduleListItem_TeamScheduleEventOccasion on TeamScheduleEventOccasion {
        __typename
        ...TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion
        ... on RoutineOccasion {
          ...TeamScheduleRoutineOccasionListItem_RoutineOccasion
          routine {
            id
            isArchived
            ...RoutineOccasionScreenRoutineDescription_Routine
          }
        }
        ... on TeamScheduleInlineRoutineOccasion {
          ...TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion
        }
      }
    `,
    props.eventOccasion
  );

  const renderContent = useCallback(() => {
    switch (eventOccasion.__typename) {
      case "TeamScheduleInlineRoutineOccasion":
        return (
          <TeamScheduleInlineRoutineOccasionListItem
            inlineRoutineOccasion={eventOccasion}
            itemType={props.itemType}
          />
        );
      case "RoutineOccasion":
        return (
          <TeamScheduleRoutineOccasionListItem
            routineOccasion={eventOccasion}
            itemType={props.itemType}
          />
        );
      default:
        return null;
    }
  }, [eventOccasion, props.itemType]);

  return (
    <TeamScheduleListItemWrapper
      isFirst={props.isFirst}
      isLast={props.isLast}
      itemType={props.itemType}
      radius={props.radius}
      border={props.border}
      showSeparator={props.showSeparator}
    >
      {props.itemType === "timeOfDay" ? (
        <TeamScheduleListItemTimeOfDay
          eventOccasion={eventOccasion}
          status={props.status}
          tint={props.teamColor}
        />
      ) : null}
      {renderContent()}
    </TeamScheduleListItemWrapper>
  );
}
